import { Box } from "@mui/material";
import CustomButton from "../../UIElements/CustomButton";
import DropDown from "../../UIElements/DropDown";
import { buildInstructorDropDownItems } from "../utils";

type BulkAssignedFooterProps = {
    instructorList: any[];
    onInstructorSelect: Function;
    handleBulkAssignedDossier: Function;
    disabledBulkAssignBtn: boolean;
    initInstructorId: number;
};

export default function BulkAssignedFooter({
    instructorList,
    onInstructorSelect,
    handleBulkAssignedDossier,
    disabledBulkAssignBtn,
    initInstructorId,
}: BulkAssignedFooterProps) {
    const instructorDropDownItems =
        buildInstructorDropDownItems(instructorList);

    const initInstructor = instructorDropDownItems.find(
        (ins) => ins.id === initInstructorId
    );

    return (
        <Box
            sx={{
                display: "flex",

                flexDirection: "column",
                alignItems: "flex-start",
                gap: "0.625rem",
                bottom: "0rem",
                padding: "2rem 4rem 4rem 4rem",
                //position: "absolute",
                borderRadius: "0rem 0rem 1.5rem 1.5rem",
                background: "#FFF",
                boxShadow: "0px 4px 30px 0px #E3E6E8",
                width: "100%",
                boxSizing: "border-box",
                "@media (max-width:1024px)": {
                    padding: "unset",
                    flexDirection: "column",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    alignSelf: "stretch",
                    "@media (max-width:1024px)": {
                        // padding: "unset",
                        gap: "0.5rem",
                        flexDirection: "column",
                    },
                }}
            >
                <DropDown
                    items={instructorDropDownItems}
                    defaultValue={initInstructor?.id ?? ""}
                    inputlabel={"Affecter un instructeur"}
                    onChange={(event) => {
                        onInstructorSelect(event.target.value);
                    }}
                    selectpx={{
                        border: "2px solid  #E3E6E8",
                        background: "#FFF",
                    }}
                    root={{
                        width: "50%",
                        "@media (max-width:1024px)": {
                            // padding: "unset",
                            width: "100%",
                        },
                    }}
                />
                <CustomButton
                    label={"Affecter les dossiers"}
                    disabled={disabledBulkAssignBtn}
                    onClick={async () => {
                        await handleBulkAssignedDossier();
                    }}
                    customsx={{
                        marginBottom: 0,
                        marginRight: 0,
                        "@media (max-width:1024px)": {
                            // padding: "unset",
                            width: "100%",
                        },
                    }}
                />
            </Box>
        </Box>
    );
}
